import React from 'react';
import {Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import {useStore} from "@/app/providers/StoreProvider";
import {ModalPayload} from "@/entities/modals/types";
import {LuckyType} from "@/entities/lucky/types";


export const LuckyModal = (payload: ModalPayload<"lucky">) => {
    const { modalStore } = useStore();

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <div className='modal_body'>

                    <h3 className='modal_title'>Поздравляем!</h3>
                    {
                        payload.itemType === LuckyType.ENERGY &&
                        <p className='modal_text'>Шайбы начислены. <br/>Можете возвращаться в игру и забивать голы! Удачи!</p>
                    }
                    {
                        payload.itemType === LuckyType.OVI_FLEX_100 &&
                        <p className='modal_text'>Клюшка OVIE FLEX 100 активирована. <br/>Возвращайтесь в игру чтобы попытаться ей забить! Удачи!</p>
                    }
                    {
                        payload.itemType === LuckyType.EMPTY_NET_10 &&
                        <p className='modal_text'>Пустые ворота на 10 ударов активированы. <br/>Возвращайтесь в игру, вратарь вам не помешает! Удачи!</p>
                    }
                    {
                        payload.itemType === LuckyType.EMPTY_NET_25 &&
                        <p className='modal_text'>Пустые ворота на 25 ударов активированы. <br/>Возвращайтесь в игру, вратарь вам не помешает! Удачи!</p>
                    }
                </div>

                <div className='modal_buttons'>
                    <button type='button' className='modal_button'
                            onClick={()=>modalStore.close()}>Вперед
                    </button>
                </div>
            </div>
        </Modal>
    );
};

